<template>
  <form @submit.prevent="handleMetaTagSubmission()" method="POST" novalidate>
    <div class="row">
      <div class="col-8">
        <div class="form-group required">
          <label class="control-label" for="meta_title">Meta title</label>
          <input
            type="text"
            id="meta_title"
            name="meta_title"
            v-model="meta.meta_title"
            v-validate="'required'"
            class="form-control"
            placeholder="meta title"
          />
          <div class="help text-danger" v-show="errors.has('meta_title')">
            {{ errors.first("meta_title") }}
          </div>
        </div>
        <div class="form-group required">
          <label class="control-label" for="meta_keywords">Meta keywords</label>
          <input
            type="text"
            id="meta_keywords"
            name="meta_keywords"
            v-validate="'required'"
            v-model="meta.meta_keywords"
            class="form-control"
            placeholder="meta keywords"
          />
          <small class="help text-info text-xs">seperated by comma</small>
          <div class="help text-danger" v-show="errors.has('meta_keywords')">
            {{ errors.first("meta_keywords") }}
          </div>
        </div>
        <div class="form-group required">
          <label class="control-label" for="meta_description"
            >Meta description</label
          >
          <input
            type="text"
            id="meta_description"
            name="meta_description"
            v-model="meta.meta_description"
            v-validate="'required'"
            class="form-control"
            placeholder="meta description"
          />
          <div class="help text-danger" v-show="errors.has('meta_description')">
            {{ errors.first("meta_description") }}
          </div>
        </div>
        <div class="form-group required">
          <label for="meta_image" class="control-label">Thumbnail</label>
          <div class="row align-items-center">
            <div class="col-4">
              <div class="input-group">
                <div class="custom-file">
                  <input
                    type="file"
                    name="meta_image"
                    class="custom-file-input"
                    id="meta_image"
                    accept="image/png, image/jpeg, image/jpg"
                    @change="selectFile"
                  />
                  <label class="custom-file-label" for="meta_image">
                    {{ temp_thumbnail_name }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-8">
              <img
                alt="preview"
                v-if="temp_thumbnail"
                :src="temp_thumbnail"
                width="100"
                height="100"
                class="img-thumbnail"
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  props: {
    meta: Object,
  },
  watch: {
    meta: {
      //immediate: true,
      handler(val, oldVal) {
        this.temp_thumbnail = this.API_ASSET_UPLOAD_URL + this.meta.meta_image;
        this.meta.meta_image = "";
      },
    },
  },
  data: () => ({
    temp_thumbnail: "",
    temp_thumbnail_name: "",
  }),
  methods: {
    selectFile(event) {
      // `files` is always an array because the file input may be in multiple mode
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        this.temp_thumbnail = reader.result;
        this.meta.meta_image = reader.result;
        this.$set(this, "temp_thumbnail_name", event.target.files[0].name);
      };
    },
    handleMetaTagSubmission() {
      let _this = this;
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          axios({
            method: "POST",
            url: "/courses/sync-metatags",
            data: _this.meta,
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "CourseList" });
            })
            .catch((errors) => {
              _this.$toaster.error(errors.response.data.message);
              if (errors.response.status === 424) {
                _this.$toaster.error(errors.response.data.errors.message);
              } else {
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
  },
};
</script>
